import { Shield, TrendingUp, Layers, LucideIcon, AlertTriangle } from "lucide-react";

export interface ArchetypeConfig {
  label: string;
  shortLabel: string;
  sublabel: string;
  icon: LucideIcon;
  color: string;
  dotColor: string;
  textColor: string;
  borderColor: string;
  headerColor: string;
  accentBg: string;
  isWarning?: boolean; // Flags options that should trigger visual escalation
  warningMessage?: string; // Explicit warning about this archetype
}

export const archetypeConfig: Record<string, ArchetypeConfig> = {
  low_risk: {
    label: "Validierungsfokus",
    shortLabel: "Valid↑",
    sublabel: "Lernen vor Wahrnehmung",
    icon: Shield,
    color: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/20",
    dotColor: "bg-emerald-500",
    textColor: "text-emerald-700 dark:text-emerald-400",
    borderColor: "border-emerald-500/30",
    headerColor: "border-l-emerald-500",
    accentBg: "bg-emerald-500/5"
  },
  value_max: {
    label: "Sichtbarkeitswette",
    shortLabel: "Sicht↑",
    sublabel: "Reichweite vor Beweisbarkeit",
    icon: TrendingUp,
    color: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20",
    dotColor: "bg-amber-500",
    textColor: "text-amber-700 dark:text-amber-400",
    borderColor: "border-amber-500/30",
    headerColor: "border-l-amber-500",
    accentBg: "bg-amber-500/5"
  },
  scaling: {
    label: "Strategischer Aufschub",
    shortLabel: "Defer",
    sublabel: "Architektur vor Marktsignal",
    icon: AlertTriangle, // Warning icon instead of Layers
    color: "bg-destructive/10 text-destructive border-destructive/20",
    dotColor: "bg-destructive",
    textColor: "text-destructive",
    borderColor: "border-destructive/30",
    headerColor: "border-l-destructive",
    accentBg: "bg-destructive/5",
    isWarning: true,
    warningMessage: "Diese Option erzeugt keine entscheidungsrelevanten Marktsignale."
  }
};

export const getArchetypeConfig = (archetype?: string): ArchetypeConfig | null => {
  if (!archetype) return null;
  return archetypeConfig[archetype] || null;
};

// Helper to get all archetype labels for display
export const getArchetypeLabels = (): string => {
  return Object.values(archetypeConfig).map(c => c.label).join(" · ");
};
